import request from '@/utils/request'
const url = 'index.php/bazaar/api/bazaar/'

//提交选中课程
export function PostSaveByData(data){
    return request({
        url: url +'Order/PostSaveByData',
        method: 'post',
        data
    })
}


//查询我的课程
export function GetItemByData(query){
    return request({
        url: url +'Order/GetItemByData',
        method: 'get',
        params: query
    })
}


/**
 * 根据用户id获取对应课程---进行报名岗位的切换
 * @param query
 * @constructor
 */
export function GetInfoThemeJobsCourse(query){
    return request({
        url: url +'Order/GetInfoThemeJobsCourse',
        method: 'get',
        params: query
    })
}


/**
 * 增加时长临时
 * @param query
 * @constructor
 */
export function GetUrlFile(query){
    return request({
        url: url +'Order/GetUrlFile',
        method: 'get',
        params: query
    })
}

/**
 * 测试替换时长
 * @param data
 * @constructor
 */
export function PostUpdateFile(data){
    return request({
        url: url +'Order/PostUpdateFile',
        method: 'post',
        data
    })
}




